module.exports = __webpack_public_path__ + "img/tenda_icon.3f75c5d9.svg";